import React from 'react';
import { withStyles, Grid, Typography, withRouter } from '../../../material-ui';



const ICON1 = require('../../../images/icons/huangpai.png');
const ICON2 = require('../../../images/icons/hongpai.png');
const ICON3 = require('../../../images/icons/jiaoqiu.png');
const ICON4 = require('../../../images/icons/jinqiu.png');
const ICON5 = require('../../../images/icons/dianqiu.png');
const ICON6 = require('../../../images/icons/huanren.png');
const ICON7 = require('../../../images/icons/lianghuanyihong.png');
const ICON8 = require('../../../images/icons/dianqiuweijin.png');
const ICON9 = require('../../../images/icons/wulong.png');

class MovieStateFootBallTextLive extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getIcon(type) {
        switch (type) {
            case 1:
                return ICON4;
            case 2:
                return ICON3;
            case 3:
                return ICON1;
            case 4:
                return ICON2;
            case 8:
                return ICON5;
            case 9:
                return ICON6;
            case 15:
                return ICON7;
            case 16:
                return ICON8;
            case 17:
                return ICON9;
        }
    }

    getColor(postion) {
        if (postion == 1) {
            return '#FC2E34';
        } else if (postion == 2) {
            return '#368BF4';
        }
        return 'transparent';
    }

    render() {
        let { classes, data } = this.props;
        return (
            <Grid container direction='column' alignItems='center' justifyContent='center' className={classes.root}>
                {
                    data && data.map((item, i) => (
                        <Grid key={i} container direction='row' alignItems='center' justifyContent='center' style={{ marginTop: 4, marginBottom: 4 }}>
                            <Grid container direction='row' alignItems='center' justifyContent='center' style={{ width: 26 }}>
                                {
                                    this.getIcon(item.type) && <img src={this.getIcon(item.type)} style={{ width: 10, height: 12.5 }}></img>
                                }
                            </Grid>
                            <Grid container direction='row' alignItems='center' justifyContent='space-between' className={classes.back}>
                                <Typography noWrap={true} className={classes.textLine}>{item.data}</Typography>
                                <Grid className={classes.linBack} style={{ backgroundColor: this.getColor(item.position) }}> </Grid>
                            </Grid>
                        </Grid>
                    ))
                }
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
    },
    back: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        backgroundColor: '#FFF',
        borderRadius: 5,
        flex: 1,
        marginRight: 8,
        maxWidth: 'calc(100% - 42px)',
    },
    linBack: {
        width: 3,
        height: 25,
        borderRadius: 1.5,
    },
    textLine: {
        color: '#0D0D0D',
        fontSize: 12,
        flex: 1,
        marginLeft: 4,
        maxWidth: 'calc(100% - 64px)',
    }

}))(MovieStateFootBallTextLive));